import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { Subscription } from 'rxjs/Subscription';

import { DOCUMENT } from '@angular/common';
import { ExternalDependencyLoader } from '../../lib/services/external-dependency-loader.service';
import { LoaderService } from '../../lib/services/loader.service';

@Component({
  selector: 'pdmi-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css']
})
export class ContentComponent implements OnInit {

  constructor(
    @Inject(DOCUMENT) private document,
    public router: Router,
    private externalDependencyLoader: ExternalDependencyLoader,
    private loaderService: LoaderService
  ) {}

  showLoader = false;
  loaderMessage = '';
  accessToken: string;

  ngOnInit() {
    this.externalDependencyLoader.load(null, './client.css');
    this.loaderService.loaderState.subscribe(state => this.showLoader = state);
    this.loaderService.loaderMessage.subscribe(message => this.loaderMessage = message);
    this.accessToken = (<HTMLInputElement>document.getElementById('access-token')).value;
  }

  resize(){
    // setTimeout(() => self.parent['resizeIframe'](), 100);
  }

}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/app/content/content.component.ts